import styled from 'styled-components';
import tw, { classnames, position, flexWrap, display, minHeight, margin, borderWidth, width, borderColor } from 'tailwindcss-classnames';

export const MainContent = styled.div.attrs({
    className: classnames(position('relative'), flexWrap('flex-wrap'), display('md:flex'), minHeight('min-h-screen'), margin('my-6'))
})``;

export const SingleAnswerContainer = styled.div.attrs({
    className: classnames(position('relative'), borderWidth('border-b-2'), width('xl:w-10/12'), borderColor('border-gray-100'))
})`
border-bottom: 1px solid;
`;